import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionsHelper } from '../../app/helpers/permissions.helper';
import { MpsUser } from '../../app/models/mps-user.model';
import { MpsUserService } from '../services/mps-user.service';
import { applicationRouteNames } from '../../app/application-route-names';

export const MpsUserManagementGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.navigateByUrl(applicationRouteNames.cylinderManagement);
  }

  const user = new MpsUser(loggedInUser);
  return PermissionsHelper.canAccessUserManagement(user)
    ? true : router.navigateByUrl(applicationRouteNames.cylinderManagement);
};
